import { useState } from 'react';
import type { AdminTabId } from './types';
import AdminSidebar from './components/AdminSidebar';
import AdminTopbar from './components/AdminTopbar';
import AdminDashboard from './components/tabs/AdminDashboard';
import AdminKlienti from './components/tabs/AdminKlienti';
import AdminProjekty from './components/tabs/AdminProjekty';
import AdminFaktury from './components/tabs/AdminFaktury';
import AdminSpravy from './components/tabs/AdminSpravy';
import AdminUlohy from './components/tabs/AdminUlohy';

const tabContent: Record<AdminTabId, JSX.Element> = {
  dashboard: <AdminDashboard />,
  klienti:   <AdminKlienti />,
  projekty:  <AdminProjekty />,
  faktury:   <AdminFaktury />,
  spravy:    <AdminSpravy />,
  ulohy:     <AdminUlohy />,
};

export default function AdminPortalPage() {
  const [activeTab, setActiveTab] = useState<AdminTabId>('dashboard');

  return (
    <div className="h-screen flex overflow-hidden bg-zinc-950">
      <title>Admin portál | Boostio</title>

      <AdminSidebar activeTab={activeTab} onTabChange={setActiveTab} />

      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        <AdminTopbar activeTab={activeTab} />

        <main className="flex-1 overflow-hidden">
          {tabContent[activeTab]}
        </main>
      </div>
    </div>
  );
}
